// Port of api/fuel/app/classes/controller/api/monty/presets/defaulted.php
import DB from 'offline/db'
import Constants from 'offline/constants'

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var id = parseInt(params.id, 10) || 0
	var preset = id ? DB.query('SELECT * FROM preset WHERE preset_id = ?', [id]) : []

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (!preset.length) {
		return Promise.reject({ error: Constants.API_ERROR_NOTFOUND, offline: true })
	}

	if (parseInt(preset[0].user_id, 10) !== userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	DB.run('UPDATE preset SET preset_default = 0 WHERE user_id = ? AND preset_type = ? AND preset_default = 1', [
		userId, preset[0].preset_type
	])
	DB.run('UPDATE preset SET preset_default = ? WHERE preset_id = ?', [
		parseInt(preset[0].preset_default, 10) ? 0 : 1,
		id
	])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {}
		}
	})
}
